import { generatePath } from 'react-router';
import { ROUTES } from '@/shared/config';

export function getPath(id: string): string {
  return generatePath(ROUTES.SCRIPTS.ITEM, { id })
}